import { Component, EventEmitter, Inject, Output } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ScheduleService } from "../../../shared/services/schedule.service";
import { SignalBoService } from "../../../shared/services/signalbo.service";
import { SignalMessage } from "../../models/SignalMessage";
import { TradePlan } from "../../models/TradePlan";
import { TradePlanService } from "../../services/tradePlan.service";

@Component({
  selector: "app-signals-delete-modal",
  templateUrl: "../templates/signalsDeleteModal.component.html",
})
export class SignalsDeleteModalComponent {
  @Output() itemDeleted: EventEmitter<SignalMessage | TradePlan> =
    new EventEmitter<SignalMessage | TradePlan>();

  private item: string;
  private tradePlan: TradePlan;
  private message: SignalMessage;
  private isScheduled: boolean;
  private inProgress: boolean;

  constructor(
    private dialogRef: MatDialogRef<SignalsDeleteModalComponent>,
    private signalBoService: SignalBoService,
    private scheduleService: ScheduleService,
    private tradePlanService: TradePlanService,
    @Inject(MAT_DIALOG_DATA)
    private _data: {
      message: SignalMessage;
      isScheduled: boolean;
      tradePlan: TradePlan;
    }
  ) {
    this.inProgress = false;
    this.item = this._data.tradePlan ? "trade plan" : "message";
    this.message = this._data.message;
    this.isScheduled = this._data.isScheduled;
    this.tradePlan = this._data.tradePlan;
  }

  async accept() {
    this.inProgress = true;
    let result;

    if (this.message) {
      result = this.handleDeleteMessage();

      if (result) {
        this.itemDeleted.emit(this.message);
      }
    }

    if (this.tradePlan) {
      result = await this.tradePlanService
        .Delete(this.tradePlan.id)
        .toPromise();

      if (result) {
        this.itemDeleted.emit(this.tradePlan);
      }
    }

    this.inProgress = false;
    this.close();
  }

  close() {
    this.dialogRef.close();
  }

  private async handleDeleteMessage() {
    let result;

    if (this.isScheduled) {
      result = await this.scheduleService
        .DeleteScheduled(this.message.id)
        .toPromise();
    }
    result = await this.signalBoService
      .DeleteMessage(this.message.id)
      .toPromise();

    return result;
  }

  public get Item() {
    return this.item;
  }
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/components/scripts/signalsDeleteModal.component.ts